import * as Highcharts from 'highcharts';
import { Observable } from 'rxjs';
import { CategoryChartConfigMap } from '../../models/config.models';

export interface BillboardConfig {
    title: string,
    iconClass: string,
    metricValue: string,
    metricTrendValue?: number,
    metricTrendInverted?: boolean,
    metricTrendArrowClass?: string,
    subtitle1Value?: string,
    subtitle2Value?: string,
    subtitle3Value?: string,
    footerOneLeftValue?: string,
    footerOneLeftLabel?: string,
    footerOneLeftColor?: string,
    footerOneRightValue?: string,
    footerOneRightLabel?: string,
    footerOneRightColor?: string,
    footerTwoLeftValue?: string,
    footerTwoLeftLabel?: string,
    footerTwoLeftColor?: string,
    footerTwoRightValue?: string,
    footerTwoRightLabel?: string,
    footerTwoRightColor?: string,
    helpTextKey: string,
    helpTextTitle: string,
    chartConfig?: Observable<Highcharts.Options>,
    chartConfigMap?: CategoryChartConfigMap
}
